import { AppointmentStatus } from '../../domain/types';
import { Appointment } from '../../providers/api/dtos/appointment';

export function getAppointmentsWithOutcome(appointments: Appointment[]) {
  return appointments.filter((appointment) => [AppointmentStatus.DONE, AppointmentStatus.CANCELLED].includes(appointment.status));
}
